import ConnectorLayout from '~/components/layouts/ConnectorLayout';
import Tile from '~/images/Tiles/Enrichment.svg';
import paths from '~/lib/paths';
import { connectorLocations } from '~/lib/segmentAnalytics';

import { IntegrationTabs } from '../IntegrationTabs';
import { TabName } from '../IntegrationTabs/types';
import { Integration } from '../Show/FieldMappingForm/types';
import { Configure } from './Configure';
import { EnrichmentAccountNotifications } from './EnrichmentAccountNotifications';
import { ListLoadError } from './ListLoadError';
import { Loading } from './Loading';
import { useStateMachine } from './useStateMachine';
import { Send, State } from './useStateMachine/types';
import { Welcome } from './Welcome';

type CustomObjectsProps = {
  integration: Integration;
  objectType: TabName;
};
export function CustomObjects({
  integration,
  objectType = 'custom-objects',
}: CustomObjectsProps) {
  const [state, send] = useStateMachine();

  return (
    <ConnectorLayout
      breadcrumb={[
        {
          title: 'Enrichment',
          path: paths.dataEnrichmentIndex(),
        },
      ]}
      connectorLocation={connectorLocations.enrichment}
      integration={integration}
      subtitle={`Sync Clearbit data to Custom Objects`}
      tabs={<IntegrationTabs integration={integration} tabName={objectType} />}
      tile={<Tile />}
    >
      <EnrichmentAccountNotifications integration={integration} />
      <div className="h-full px-8">
        <CustomObjectsScreens send={send} state={state} />
      </div>
    </ConnectorLayout>
  );
}

type CustomObjectsScreensProps = {
  state: State;
  send: Send;
};
function CustomObjectsScreens({ state, send }: CustomObjectsScreensProps) {
  if (state.matches('idle')) {
    return <Welcome onGetStarted={() => send('LOAD')} />;
  } else if (state.matches('loading')) {
    return <Loading />;
  } else if (state.matches('loadError')) {
    return <ListLoadError onRetry={() => send('RETRY')} />;
  }

  return <Configure send={send} state={state} />;
}
